module.exports = __webpack_public_path__ + "img/banner.3ccc50c4.png";